import { useMutation } from "@tanstack/react-query";

import type { ConversationMessage } from "./useRecentVibeChatSessions";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { jsonAuthHeaders } from "@/utils/headers";

interface CancelVibeChatRequest {
  sessionId: string;
  conversationHistory?: ConversationMessage[];
}

interface CancelVibeChatResponse {
  success: boolean;
  message?: string;
  history_saved?: boolean;
}

export const useCancelVibeChat = () => {
  const auth = useAuth();

  return useMutation({
    mutationFn: async ({
      sessionId,
      conversationHistory,
    }: CancelVibeChatRequest): Promise<CancelVibeChatResponse> => {
      if (!auth?.userToken) {
        throw new Error("Authentication required");
      }

      const response = await fetch(ENDPOINTS.cancel_vibe_chat, {
        method: "POST",
        headers: jsonAuthHeaders(auth.userToken),
        body: JSON.stringify({
          session_id: sessionId,
          conversation_history: conversationHistory,
        }),
      });

      if (!response.ok) {
        if (response.status === 404) {
          throw new Error("Session not found");
        }
        throw new Error("Failed to cancel chat session");
      }

      return response.json();
    },
  });
};
